import React from 'react'
import { Navigate } from 'react-router-dom'
import { StaffScope } from '@constants/Settings/staffPermission.const'
import { hasStaffScope } from '@utils/staffScope.util'

type ScopeRouteProps = {
  require: StaffScope | StaffScope[]
  redirectTo?: string
  children: React.ReactElement
}

const ScopeRoute = ({
  require,
  redirectTo = '/',
  children,
}: ScopeRouteProps): React.ReactElement => {
  const required = Array.isArray(require) ? require : [require]
  if (!hasStaffScope(...required)) {
    return <Navigate to={redirectTo} replace />
  }
  return children
}

export default ScopeRoute
